import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import {API_URL} from "../utils/api";
import axios  from "axios";
import { useParams } from 'react-router-dom';

const AddServiceGallery = (props) => {

  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState(null);
   const [service_id, setServiceID] = useState(0);
  const [thumbnail, setThumbnail] = useState("");
  
  const [serviceIDErr, setServiceIDErr] = useState(false);
  const [thumbnailErr, setThumbnailErr] = useState(false);
  
  const [serviceList, setServicesList] = useState([]);
  let { serviceid } = useParams();
    
  useEffect(() => {
    // Fetch data
     setServiceID(serviceid);
    axios.get(process.env.REACT_APP_API_BASE_URL+"service-list")
        .then(response => {
            setServicesList(response.data.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
}, []);


  const handleRemoveImage = () => {
    setImagePreview(null);
    setThumbnailErr(true);
  };
 
  const handleFileChange = async(e) => {
    if (e.target.files && e.target.files.length > 0) {
      var targetFile = e.target.files[0];
      const src = URL.createObjectURL(targetFile);
      setThumbnail(targetFile);
      setImagePreview(src);
      setThumbnailErr(false);
 
    }
  };

 
  const handleSubmit = () => {
    
    if(service_id != "" && thumbnail != ""){
    var formData = {
      service_id : service_id,
      image : thumbnail
    };
    console.log(formData);
    axios.post(process.env.REACT_APP_API_BASE_URL+"images-service-add", { ...formData }, {
      headers: {
        "content-type": "multipart/form-data"
      },
      
    })
      .then((res) => {
          console.log(res.data);
          // return false;
        if(res.data.status === true){
            toast.success('Image added sucessfully!!');
            setTimeout(() => {
              navigate('/'+JSON.parse(localStorage.getItem('activeUser')).user_type+'/service-gallery/'+service_id);
            }, 2000);
        }
        else{
          alert("something went wrong...")
        }
      })
      .catch(err => {
        console.error(err);
        alert(err);
      });

    } else {
     
      if(service_id == ""){
        setServiceIDErr(true);
      }
      if(thumbnail == ""){
        setThumbnailErr(true);
      } 
    
    }
  }

const serviceOptions =  serviceList.map((service) => {
    return (<option value={service.id} >{service.title}</option>)
})

  return (
    <div className='row gy-4'>
      <div className='col-lg-12'>
        <div className='card mt-24'>
          <div className='card-header border-bottom'>
            <h6 className='text-xl mb-0'>Add Service Gallery</h6>
          </div>
          <ToastContainer></ToastContainer>
          <div className='card-body p-24'>
            
              <div>
                <label
                  className='form-label fw-bold text-neutral-900'
                  htmlFor='title'
                >
                  Select Service:{" "}
                </label>
                <select
                  onChange={(e) => {
                    setServiceID(e.target.value)
                    setServiceIDErr(true);
                    if(e.target.value !== ""){
                        setServiceIDErr(false);
                    }
                  
                  }}
                   className={serviceIDErr?'form-control border border-red radius-8':'form-control border border-neutral-200 radius-8'}
                   id='service_id'
                   name="service_id"
                   value={service_id}
                  placeholder='Select Service'
                >
<option value={""}   >  Select Service </option>
{serviceOptions}

                </select>
                 {serviceIDErr && (
                        <span className="error-message">
                            {'Service is mandatory'}
                        </span>
                    )} 
              </div>
              
              
              <div>
                <label className='form-label fw-bold text-neutral-900'>
                  Upload Image
                </label>
                <div className='upload-image-wrapper'>
                  {imagePreview ? (
                    <div className='uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50'>
                      <button
                        type='button'
                        className='uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle'
                        onClick={handleRemoveImage}
                      >
                        <iconify-icon
                          icon='radix-icons:cross-2'
                          className='text-2xl text-white'
                        ></iconify-icon>
                      </button>
                      <img
                        id='uploaded-img__preview'
                        className='w-100 h-100 object-fit-cover'
                        src={imagePreview}
                        alt='Uploaded'
                      />
                    </div>
                  ) : (
                    <label
                      className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1'
                      htmlFor='upload-file'
                    >
                      <iconify-icon
                        icon='solar:camera-outline'
                        className='text-xl text-secondary-light'
                      ></iconify-icon>
                      <span className='fw-semibold text-secondary-light'>
                        Upload
                      </span>
                      <input
                        id='upload-file'
                        type='file'
                        hidden
                        onChange={handleFileChange}
                      />
                    </label>
                  )}
                  {thumbnailErr && (
                        <span className="error-message">
                            {'Attachment is mandatory'}
                        </span>
                    )}
                </div>
              </div>
              
              
              <br></br>
              <button onClick={() => handleSubmit()} className='btn btn-primary-600 radius-8'>
                Submit
              </button>
            
          </div>
        </div>
      </div>
      {/* Sidebar Start */}
    </div>
  );
};

export default AddServiceGallery;
